import {ILimitsFeesResponse} from '@/dataSource/src/api/payment-link/v2/models';
import {PaymentMethodType} from '@/dataSource/src/api/payment-link/v2/types';

// Fee for a given amount: a percentage of the amount plus a flat fee.
export function calculateFee(
  amount: number,
  flatFee: number,
  percentageFee: number,
): number {
  const perc = (amount * percentageFee) / 100;
  return parseFloat((perc + flatFee).toFixed(2));
}

// Processing fee for the selected payment method, from the limits/fees config.
export function getPaymentFee(
  receiverAmount: number,
  selectedMethod: PaymentMethodType | undefined,
  limitsFees: ILimitsFeesResponse | undefined,
): number {
  if (!selectedMethod || !limitsFees?.fees?.length) return 0;
  const rule = limitsFees.fees.find(fee => fee.type === selectedMethod);
  if (!rule) return 0;
  return calculateFee(receiverAmount, rule.flat_fee, rule.percentage_fee);
}

// Total the payer is charged ("You pay"): receiver amount + method fee.
export function getPaymentTotal(
  receiverAmount: number,
  selectedMethod: PaymentMethodType | undefined,
  limitsFees: ILimitsFeesResponse | undefined,
): number {
  if (!Number.isFinite(receiverAmount)) return 0;
  const total =
    receiverAmount + getPaymentFee(receiverAmount, selectedMethod, limitsFees);
  return parseFloat(total.toFixed(2));
}
